import DOMPurify from "dompurify";

const htmlEscapes: Record<string, string> = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	'"': "&quot;",
	"'": "&#39;",
};

/** Encodes text so it shows as typed when placed in HTML, in an element or a quoted attribute */
export function escapeHtml(text: string) {
	return (text ?? "").replace(/[&<>"']/g, (char) => htmlEscapes[char]);
}

/**
 * Removes anything from HTML that can run script: script and iframe tags, event handler attributes and
 * javascript: urls. Use it on HTML from the server or a user before rendering it (react-html-parser does no
 * sanitizing of its own, and React 18 renders javascript: urls).
 */
export function sanitizeHtml(html: string) {
	if (!html) return "";
	return DOMPurify.sanitize(html);
}
